import { toRadians } from './geo';

export const TILE_SIZE = 256;

/** Global pixel x of a longitude at zoom z (Web Mercator, 256 px tiles). */
export const lngToPx = (lng: number, z: number) => ((lng + 180) / 360) * TILE_SIZE * 2 ** z;

/** Global pixel y of a latitude at zoom z (Web Mercator, 256 px tiles). */
export const latToPx = (lat: number, z: number) => {
  const s = Math.sin(toRadians(lat));
  return (0.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI)) * TILE_SIZE * 2 ** z;
};

/** Ground resolution at zoom 0 for the given latitude, metres per pixel. */
export const metresPerPxAtZoom0 = (lat: number) => 156543.03 * Math.cos(toRadians(lat));

/** Web Mercator y of a latitude, 0 (north edge) to 1 (south edge). */
export const mercatorY = (lat: number) => latToPx(lat, 0) / TILE_SIZE;

/** Latitude of a Web Mercator y (0 north edge … 1 south edge). */
export const mercatorLat = (y: number) => (360 / Math.PI) * Math.atan(Math.exp(Math.PI * (1 - 2 * y))) - 90;
